import { getReq, postReq, createUrl } from "@/infra/http";
import { PagedResponseModel, BaseResponseModel, SelectModel } from "@/models/core.model";
import { Link, LinksPaginationFilterRequest, UpsertLink } from "@/models/link.model";

export const getPagedLinks = async (input: LinksPaginationFilterRequest): Promise<PagedResponseModel<Link>> => {
  return await getReq(createUrl("a/Link/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};
export const getLinksLookup = async (text?: string, runningClubId?: number): Promise<SelectModel[]> => {
  const model: LinksPaginationFilterRequest = {
    pageNumber: 1,
    pageSize: 100,
    isAscending: false,
    keyword : text,
    runningClubId : runningClubId,
  };
  return await getPagedLinks(model).then(data => data.result.map(l => ({ label: l.name ?? '', value: l.id })));
};
export const getLink = async (id: number): Promise<BaseResponseModel<Link>> => {
  return await getReq(createUrl(`a/Link/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertLink = async (input: UpsertLink): Promise<BaseResponseModel<Link>> => {
  return await postReq(createUrl("a/Link/Upsert"),
    input
  ).then((res: any) => res.data);
};
